import { Box, Typography } from "@mui/material";
import { BOARD_SIZE, PieceVisual } from "./TestPieceVisual";

function unitRandom(seed) {
    const x = Math.sin(seed * 12.9898 + 78.233) * 43758.5453;
    return x - Math.floor(x);
}

export function buildScatterPositions(total, grid, templateKey) {
    const cellPx = BOARD_SIZE / grid;
    const pad = cellPx * 0.25;
    const span = Math.max(0, BOARD_SIZE - cellPx - 2 * pad);
    const key = String(templateKey ?? "default");
    let h = 0;
    for (let c = 0; c < key.length; c += 1) h = (h * 31 + key.charCodeAt(c)) | 0;
    const out = {};
    for (let i = 0; i < total; i += 1) {
        const s1 = h + i * 7919 + 1;
        const s2 = h + i * 104729 + 7;
        out[i] = {
            x: pad + unitRandom(s1) * span,
            y: pad + unitRandom(s2) * span,
        };
    }
    return out;
}

/** Copy of pages jigsaw CanvasScattered for admin canvas tests. */
export default function TestCanvasScattered({
    scatteredRef,
    piecesNotOnBoard,
    scatterPositions,
    grid,
    imageUrl,
    paths,
    dragging,
    onScatteredPieceMouseDown,
    showPieceGridCoords = true,
}) {
    return (
        <Box sx={{ width: BOARD_SIZE }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Scattered — drag pieces anywhere in this tray; drop on the board to place, or here from the board to
                remove
            </Typography>
            <Box
                ref={scatteredRef}
                sx={{
                    position: "relative",
                    width: BOARD_SIZE,
                    height: BOARD_SIZE,
                    bgcolor: "grey.900",
                    borderRadius: 1,
                    overflow: "visible",
                }}
            >
                {piecesNotOnBoard.map((pieceIndex) => {
                    const pos = scatterPositions[pieceIndex];
                    if (!pos) return null;
                    const isDraggingThis = dragging?.pieceIndex === pieceIndex && dragging?.fromScattered;
                    return (
                        <div
                            key={pieceIndex}
                            onMouseDown={(e) =>
                                onScatteredPieceMouseDown(e, pieceIndex, { scatterX: pos.x, scatterY: pos.y })
                            }
                            style={{
                                position: "absolute",
                                left: pos.x,
                                top: pos.y,
                                cursor: "grab",
                                opacity: isDraggingThis ? 0.3 : 1,
                                zIndex: 1,
                            }}
                        >
                            <PieceVisual
                                pieceIndex={pieceIndex}
                                imageUrl={imageUrl}
                                grid={grid}
                                paths={paths}
                                showGridCoords={showPieceGridCoords}
                            />
                        </div>
                    );
                })}
            </Box>
        </Box>
    );
}
